import { render, staticRenderFns } from "./detailsHeader.vue?vue&type=template&id=5712de7f&scoped=true&"
import script from "./detailsHeader.vue?vue&type=script&lang=js&"
export * from "./detailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./detailsHeader.vue?vue&type=style&index=0&id=5712de7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712de7f",
  null
  
)

export default component.exports